import CryptoJS from 'crypto-js'

let key = 'wqslxp12nf60mzp3'
let iv = '567jiopmnbgtredc'

let hostname = window.location.hostname;
// console.log(hostname,)
let localhost = "localhost",
  development = "fusui.rural.whdev.vpclub.cn",
  preprod = "kf.vpclub.cn",
  test = "zct.gov.vpclub.cn",
  test1 = "rural.gov.vpclub.cn",
  test2 = "inside-rural-pc.web.172.16.125.12.xip.io",
  product = "rural.zct.gjsc.info",
  product1 = "rural.baise.gjsc.info",
  fusui = "rural.zct.fusui.gjsc.info",
  fusui1 = "jyzx.fusui.gjsc.info",
  fusui2 = "jyzx.fusui.vpclub.cn",
  fusui3 = "jyzx.gxfusui.com";
// http://jyzx.fusui.vpclub.cn/#/home
switch (hostname) {
  case test:
  case test1:
  case test2:
  case localhost:
  case development:
  case preprod:
    key = 'wqslxp12nf60mzp3'
    iv = '567jiopmnbgtredc'
    break
  case product:
  case product1:
    key = 'Wtrssxa26fKfxp21'
    iv = '04YhmwXcgYuoPf6D'
    break
  case fusui:
  case fusui1:
  case fusui2:
  case fusui3:
    key = 'Iyx712xYoPm90pxy'
    iv = '1xCg5bxcq9i8mxz8'
    break
  default:
    key = 'Iyx712xYoPm90pxy'
    iv = '1xCg5bxcq9i8mxz8'
    break
}

// 加密
function encrypt(word) {
  const keydata = CryptoJS.enc.Utf8.parse(key);
  const ivdata = CryptoJS.enc.Utf8.parse(iv);

  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, keydata, {
    iv: ivdata,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });

  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}
// 解密
function decrypt(data, keyQr = '', ivQr = '') { //key,iv：16位的字符串
  let keydata = CryptoJS.enc.Latin1.parse(keyQr || key);
  let ivdata = CryptoJS.enc.Latin1.parse(ivQr || iv);
  let decrypted = CryptoJS.AES.decrypt(data, keydata, {
    iv: ivdata,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

export default {
  encrypt,
  decrypt
}
